module.exports = __webpack_public_path__ + "static/media/TradeCitySS.171d4c77.png";